
/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { VariablesTableRow } from "../../../../../../ScenarioAnalysis/ViewModel/VariablesTable";

export const defaultYLabel = { variable_name: "actor.d_lat_detect", display_name: "Actor Lateral Detection Distance - Y (m)" }
export const defaultXLabel = { variable_name: "actor.d_long_detect", display_name: "Actor Longitudinal Detection Distance - X (m)" }

/**
 * Converts a DOE (Design of Experiments) variable name to its display name.
 *
 * @param variableName - The name of the variable to convert, ex: actor.t_premerge, shape.diameter...etc
 * @param doe_table_data - An array of objects representing DOE table data, where each object 
 *                         contains at least a `variable_name` and `display_name` property.
 * @returns The display name of the variable if found, otherwise returns the original variable name.
 */
export const convertDoeToReadableName = (variableName: string, doe_table_data: VariablesTableRow[]) => {
    const param = doe_table_data.find((d) => d.variable_name === variableName)
    let unitsLabel = ""
    if (param?.units) {
        unitsLabel = ` (${param.units})`
    }
    return param ? param.display_name + unitsLabel: variableName
}